import { usePermissions } from 'commons/customHooks'
import { SCREENS } from 'commons/utils/permissions'
import { Page } from 'components'

import { Dashboard } from './components/Dashboard'
import { Gallery } from './components/Gallery'
import { GoalProgress } from './components/GoalProgress'
import { Links } from './components/Links'
import { Content } from './styles'

function Home() {
  const { verifyPermission } = usePermissions()

  return (
    <Page>
      <Content>
        <Gallery />
        <Dashboard />
        {verifyPermission(SCREENS.RANKING) && <GoalProgress />}
        <Links />
      </Content>
    </Page>
  )
}

export default Home
